import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+1.200',
  label: 'Usuarios usando el sistema'
}, {
  value: '4.9/5',
  label: 'Valoración promedio'
}, {
  value: '+400',
  label: 'Prompts listos para usar'
}, {
  value: '#1',
  label: 'Sistema enfocado en diseño vendible'
}];
export function StatsBar() {
  return <section className="py-8 md:py-12 border-y border-neutral-800/50 bg-neutral-900/30" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 text-center" data-id="element-137">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-138">
              <span className="font-bebas text-4xl md:text-5xl text-brand-500 mb-2" data-id="element-139">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-neutral-400 font-medium max-w-[200px]" data-id="element-140">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}